// ASF Suche - Tippfehler-Korrektur (Sept. 2026)
// Ersatz für die Synonyme aus Search & Discovery (dort seit ca. 16.09.2026 nicht
// mehr verfügbar). Korrigiert bekannte Tippfehler wortweise, z. B.
// "kinchi" -> "kimchi", "kinchi rezept" -> "kimchi rezept".
//
// Greift an drei Stellen:
// 1) Suchmodal (Live-Ergebnisse): Anfragen an /search/suggest werden mit dem
//    korrigierten Begriff gestellt, oberhalb der Treffer steht ein Hinweis.
//    Betrifft automatisch auch "Passende Rezepte" (asf-search-recipes.js).
// 2) Absenden eines Suchformulars (Enter, "Alle anzeigen"): q wird korrigiert,
//    der Originalbegriff läuft als Parameter asf_typo mit.
// 3) Direkter Aufruf von /search?q=<Tippfehler>: Weiterleitung auf den
//    korrigierten Begriff (Fallback, z. B. für alte Links).
// Auf der Ergebnisseite erscheint ein Hinweis mit Link "Doch nach ... suchen"
// (Parameter asf_notypo=1 schaltet die Korrektur ab) und das GA4-Event
// search_typo_corrected (search_term_original, search_term) geht an den dataLayer.
//
// NEUE TIPPFEHLER: nur unten in TYPOS ergänzen, alles klein geschrieben,
// ein Eintrag je falscher Schreibweise. Nur ganze Wörter werden ersetzt.
// Siehe Projekt-Doc "Umbau_Suchfunktion_Briefing.md".
(function () {
  if (window.__asfSearchTyposLoaded) return;
  window.__asfSearchTyposLoaded = true;

  var TYPOS = {
    'rahmen': 'ramen',
    'hosin': 'hoisin',
    'hoosin': 'hoisin',
    'sirachia': 'sriracha',
    'siracha': 'sriracha',
    'sirs': 'sriracha',
    'kinchi': 'kimchi',
    'masaman': 'massaman'
  };

  function correct(term) {
    if (!term) return term;
    return term.replace(/\S+/g, function (word) {
      var fix = TYPOS[word.toLowerCase()];
      return fix || word;
    });
  }

  function isCorrected(original, corrected) {
    return !!original && original.toLowerCase() !== corrected.toLowerCase();
  }

  window.asfCorrectSearchTerm = correct;

  var params = new URLSearchParams(window.location.search);
  var optOut = params.get('asf_notypo') === '1';

  // --- 3) Ergebnisseite direkt mit Tippfehler aufgerufen -> weiterleiten -----
  var isSearchPage = /\/search\/?$/.test(window.location.pathname);
  if (isSearchPage && !optOut && !params.get('asf_typo')) {
    var q = params.get('q') || '';
    var fixed = correct(q);
    if (isCorrected(q, fixed)) {
      params.set('q', fixed);
      params.set('asf_typo', q);
      window.location.replace(window.location.pathname + '?' + params.toString());
      return;
    }
  }

  // --- 1) Suchmodal: Predictive-Search-Anfragen umschreiben ----------------
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' || input instanceof URL) {
          var url = new URL(String(input), window.location.origin);
          if (/\/search\/suggest(\.json)?$/.test(url.pathname) && url.searchParams.has('q')) {
            var term = url.searchParams.get('q');
            var fixedTerm = correct(term);
            if (isCorrected(term, fixedTerm)) {
              url.searchParams.set('q', fixedTerm);
              input = url.origin === window.location.origin
                ? url.pathname + url.search
                : url.toString();
            }
          }
        }
      } catch (e) {
        // Bei Fehlern unverändert weiterreichen.
      }
      return originalFetch.call(this, input, init);
    };
  }

  function updateDrawerHint(root) {
    var input = root.querySelector('input[name="q"]');
    var slot = root.querySelector('[slot="results"]');
    if (!input || !slot) return;

    var term = input.value || '';
    var fixedTerm = correct(term);
    var hint = slot.querySelector(':scope > .asf-typo-hint');
    var hasResults = slot.children.length > (hint ? 1 : 0);

    if (!isCorrected(term, fixedTerm) || !hasResults) {
      if (hint) hint.remove();
      return;
    }

    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'asf-typo-hint text-subdued';
      slot.insertBefore(hint, slot.firstChild);
    }
    var text = 'Ergebnisse für \u201E' + fixedTerm + '\u201C';
    if (hint.textContent !== text) hint.textContent = text;
  }

  // --- 2) Formular absenden: q korrigieren, Original mitgeben ---------------
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var action = form.getAttribute('action') || '';
    if (!/\/search\/?$/.test(action)) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var term = input.value;
    var fixedTerm = correct(term);
    if (!isCorrected(term, fixedTerm)) return;

    input.value = fixedTerm;
    var marker = form.querySelector('input[name="asf_typo"]');
    if (!marker) {
      marker = document.createElement('input');
      marker.type = 'hidden';
      marker.name = 'asf_typo';
      form.appendChild(marker);
    }
    marker.value = term;
  }, true);

  // --- Hinweis auf der Ergebnisseite + GA4-Event ---------------------------
  function showResultsPageHint() {
    var original = params.get('asf_typo');
    if (!isSearchPage || !original) return;

    var current = params.get('q') || '';
    var heading = document.querySelector('.shopify-section--main-search h1');
    if (heading && !document.querySelector('.asf-typo-hint--page')) {
      var hint = document.createElement('p');
      hint.className = 'asf-typo-hint asf-typo-hint--page text-subdued text-center';
      hint.appendChild(document.createTextNode(
        'Du hast \u201E' + original + '\u201C gesucht. Wir zeigen dir die Ergebnisse f\u00FCr \u201E' + current + '\u201C. '
      ));

      var link = document.createElement('a');
      var optOutParams = new URLSearchParams();
      optOutParams.set('q', original);
      optOutParams.set('type', params.get('type') || 'product');
      optOutParams.set('asf_notypo', '1');
      link.href = window.location.pathname + '?' + optOutParams.toString();
      link.className = 'link';
      link.textContent = 'Doch nach \u201E' + original + '\u201C suchen';
      hint.appendChild(link);

      heading.insertAdjacentElement('afterend', hint);
    }

    var page = params.get('page');
    if (!page || page === '1') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'search_typo_corrected',
        search_term_original: original,
        search_term: current
      });
    }
  }

  function initDrawers() {
    document.querySelectorAll('search-drawer').forEach(function (root) {
      var input = root.querySelector('input[name="q"]');
      var slot = root.querySelector('[slot="results"]');
      if (!input || !slot) return;

      new MutationObserver(function () {
        updateDrawerHint(root);
      }).observe(slot, { childList: true, subtree: false });

      input.addEventListener('input', function () {
        updateDrawerHint(root);
      });
    });
  }

  function init() {
    showResultsPageHint();
    initDrawers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();